import { defineStore } from 'pinia'
export const useChatStore = defineStore('chat', {
  state: () => ({
    roomId: '',
    imgProduct: null,
    imgMask: null,
    imgEdit: null,
    aiCreateMessage: '',
    chat: {
      room_id: '',
      state: 0, // 0: 初始化，未加入房间；1: 刚提交，但还没有收到 socket 信息，前端自行添加一条custom-msg-warning；2: 开始接收 socket 信息；3: 对话已经完成；-1: 对话出错
      messages: [],
    },
  }),
  actions: {
    setRoomId(id: string) {
      this.roomId = id
    },
    setImgProduct(img: any) {
      this.imgProduct = img
    },
    setImgMask(img: any) {
      this.imgMask = img
    },
    setImgEdit(img: any) {
      this.imgEdit = img
    },
    setAiCreateMessage(msg: string) {
      this.aiCreateMessage = msg
    },
    initChat() {
      this.chat = {
        room_id: '',
        state: 0,
        messages: [],
      }
    },
    setChat(chat: any) {
      this.chat = chat
    },
  },
})
